import { useDeleteBatch } from '@api/hooks/useBatch.ts';
import { ConfirmModal } from '@components/ConfirmModal';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface DeleteFullBatchProps {
	id: string;
	fileName: string;
	disabled?: boolean;
}

export const DeleteFullBatch = ({ id, fileName, disabled }: DeleteFullBatchProps) => {
	const navigate = useNavigate();
	const deleteBatch = useDeleteBatch();
	const { t } = useTranslation('', { keyPrefix: 'payments.batch.modal' });

	const handleDeleteBatch = async (batchId: string) => {
		await deleteBatch.mutateAsync({ id: batchId });
		navigate('/operations/batch');
	};

	return (
		<ConfirmModal
			cancelKey={t('cancel')}
			disabled={disabled}
			id={id}
			onRemove={handleDeleteBatch}
			submitKey={t('accept')}
			titleKey={t('description', { transactionName: fileName })}
		/>
	);
};
